<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-06-10 17:01:53
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-09 16:26:32
 * @Description: 更多精彩，聊天，分享 
 -->
<template>
  <div class="tabbar3">
    <div
      v-for="item in evenNavData"
      class="tabbar_item"
      @click="clickItem(item)"
      :class="item.class"
      :style="item.style"
    >
      <div class="tabbar_icon">
        <img :src="item.ico" />
      </div>
      <span class="tabbar_text">{{item.name}}</span>
    </div>
    <HdkShare v-if="isShowHdkShare" v-on:close="closeHdkShare"></HdkShare>
    <ShareGuide v-if="isShowShareGuide" v-on:close="closeShareGuide"></ShareGuide>
    <ShowImg2 v-if="showImg2.isShow" :my="showImg2" v-on:close="showImg2.isShow=false"></ShowImg2>
    <SaveAddressList v-if="isShowSaveAddressList" v-on:close="isShowSaveAddressList=false"></SaveAddressList>
  </div>
</template>
<script>
import * as comreq from "@/utils/comreq";
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
import createimg from "@/utils/createimg";
const HdkShare = () => import("@/components/hdk-share.vue");
const ShowImg2 = () => import("@/components/showimg2.vue");
const ShareGuide = () => import("@/components/share_guide3.vue");
const SaveAddressList = () => import("@/components/save-address-list.vue");
export default {
  components: {
    HdkShare,
    ShareGuide,
    ShowImg2,
    SaveAddressList
  },
  props: {},
  data() {
    return {
      myw: "20%",
      //底部导航
      navData: [
        {
          name: "更多精彩",
          click: "clickWonder",
          style: {
            width: "27%"
          },
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar3/gengduojingcai_no.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar3/gengduojingcai_no.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar3/gengduojingcai_yes.png?x-oss-process=image/resize,h_100,w_100"
        },
        {
          name: "存通讯录",
          click: "clickSaveAddressList",
          style: {
            width: "27%"
          },
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar3/tongxunlu_no.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar3/tongxunlu_no.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar3/tongxunlu_yes.png?x-oss-process=image/resize,h_100,w_100"
        },
        {
          name: "",
          click: "clickChat",
          style: {
            width: "17%"
          },
          class: "tabbar_item_chat",
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar3/chat.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar3/chat.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar3/chat.png?x-oss-process=image/resize,h_100,w_100"
        },
        {
          name: "存名片图",
          click: "clickSaveCardImg",
          style: {
            width: "27%"
          },
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar3/cunmingpian_no.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar3/cunmingpian_no.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar3/cunmingpian_yes.png?x-oss-process=image/resize,h_100,w_100"
        },
        {
          name: "免费领取",
          click: "clickFreeCollection",
          style: {
            width: "27%"
          },
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar3/mianfeilingqu_no.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar3/mianfeilingqu_no.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar3/mianfeilingqu_yes.png?x-oss-process=image/resize,h_100,w_100"
        }
      ],
      showImg2: {
        isShow: false,
        url: "",
        width: "",
        intro: ""
      },
      isShowHdkShare: false, //是否显示小程序分享
      isShowShareGuide: false, //是否显示网页分享
      isShowSaveAddressList: false, //是否显示存通讯录
      imgUrlCardPoster: ""
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isLoading",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ]),
    evenNavData: function() {
      return this.navData.filter(function(item, i) {
        return item.isHide != true;
      });
    }
  },
  methods: {
    clickItem(item) {
      this[item.click]();
    },
    // 更多精彩
    clickWonder() {
      let that = this;
      let imgUrl =
        "https://assets.rurushishi.com/yq-rs-make/other/henduobao_code.jpg"; //很多宝公众号二维码
      if (this.isInMiniProgram) {
        // 很多宝
        util.navigateToShareMomentsPageReturnImg(
          this,
          {
            // title: "关注很多宝公众号，天天都有高净值精彩内容免费更新",
            // desc: "24位您的朋友已经关注了",
            // img:
            //   "https://assets.rurushishi.com/yq-rs-make/other/henduobao_icon.png",
            sendMessageTitle:
              "关注很多宝公众号，天天都有高净值精彩内容免费更新",
            sendMessageImg:
              "http://assets.wxmp.ruthus.com/henduoke/share_moments/icon6.png",
            // intro: "关注很多宝公众号，天天都有高净值精彩内容免费更新"
            action:'qr_subscribe_gzh_hdb'
          },
          imgUrl
        );
      } else {
        that.showImg2 = {
          url: imgUrl,
          width: "50%",
          intro: "扫码关注，为您汇聚高净值精彩内容！",
          isShow: true
        };
      }
    },
    // 存通讯录
    clickSaveAddressList() {
      if (
        this.cardInfo &&
        this.cardInfo.User &&
        this.cardInfo.User.BusinessCardImg
      ) {
        this.showImg2 = {
          url: this.cardInfo.User.BusinessCardImg,
          width: "80%",
          intro: "亲，请长按保存！",
          isShow: true
        };
      } else {
        this.isShowSaveAddressList = true;
      }
    },
    // 咨询
    clickChat() {
      comreq.actAdv(this, this.$enumUserEvent.spreadChat);
      util.openChat(this);
    },
    // 存名片图
    clickSaveCardImg() {
      let that = this;
      if (that.imgUrlCardPoster) {
        this.showImg2 = {
          url: this.imgUrlCardPoster,
          width: "80%",
          intro: "亲，请长按保存！",
          isShow: true
        };
      } else {
        that.$setLoading(true);
        util.checkMapStateCallback(that, ["cardInfo"]).then(() => {
          createimg.getPoster(that).then(imgUrl => {
            that.$setLoading(false);
            that.imgUrlCardPoster = imgUrl;
            that.showImg2 = {
              url: that.imgUrlCardPoster,
              width: "80%",
              intro: "亲，请长按保存！",
              isShow: true
            };
          });
        });
      }
    },
    // 免费领取
    clickFreeCollection() {
      let that = this;
      let imgUrl =
        "https://assets.rurushishi.com/yq-rs-make/other/henduoke_code.jpg"; //很多客公众号二维码
      if (this.isInMiniProgram) {
        // 很多客
        util.navigateToShareMomentsPageReturnImg(
          this,
          {
            // title: "关注很多客公众号，天天都有高净值精彩获客内容免费更新",
            // desc: "24位您的朋友已经关注了",
            // img:
            //   "https://assets.rurushishi.com/yq-rs-make/other/henduoke_icon.png",
            sendMessageTitle:
              "关注很多客公众号，天天都有高净值精彩获客内容免费更新",
            sendMessageImg:
              "http://assets.wxmp.ruthus.com/henduoke/share_moments/icon5.png",
            // intro: "关注很多客公众号，天天都有高净值精彩获客内容免费更新"
            action:'qr_subscribe_gzh_hdk'
          }
        );
      } else {
        that.showImg2 = {
          url: imgUrl,
          width: "50%",
          intro: "扫码关注，免费获取AI获客神器！",
          isShow: true
        };
      }
    },
    // 关闭小程序分享
    closeHdkShare() {
      this.isShowHdkShare = false;
    },
    // 关闭网页分享引导
    closeShareGuide() {
      this.isShowShareGuide = false;
    }
  },
  created() {
    // 如果在小程序里面显示的底部菜单，隐藏“更多精彩”。20190705日说不添加了。
    // if (this.isInMiniProgram) {
    //   this.navData[0].isHide;
    // }
    // 提前准备好海报图
    let that = this;
    util.checkMapStateCallback(that, ["cardInfo"]).then(() => {
      createimg.getPoster(that).then(imgUrl => {
        that.imgUrlCardPoster = imgUrl;
      });
    });
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
/* 底部导航 */
.tabbar3 {
  width: 100%;
  height: 50px;
  background: #fff;
  /* background: #f5af19; */
  /* background: linear-gradient(to right, #f5af19, #f12711); */
  /* background: linear-gradient(to right, #4CB8E9, #007DA6); */
  position: fixed;
  bottom: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-top: 1px solid #c6c6c6;
}

.tabbar_item {
  text-align: center;
  position: relative;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333333;
  flex-direction: column;
}

.tabbar_icon {
}

.tabbar_icon > img {
  width: 18px;
  height: 18px;
}

.tabbar_text {
  padding-top: 5px;
  display: inline-block;
  font-size: 12px;
}
.tabbar_item_chat {
}
.tabbar_item_chat img {
  width: 60px;
  height: 60px;
  margin-top: -30px;
}
</style>